var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserSvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 20 24",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#6f6e89",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.67417,
    cy: 6.46836,
    opacity: 0.4,
    r: 5.46836
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m1.00002 19.5426c-.001471-.3844.0845-.7642.25142-1.1105.52379-1.0475 2.00087-1.6027 3.22654-1.8542.88395-.1886 1.78011-.3146 2.6818-.3771 1.66942-.1466 3.34852-.1466 5.01792 0 .9016.0632 1.7977.1892 2.6818.3771 1.2256.2515 2.7027.7543 3.2265 1.8542.3357.706.3357 1.5255 0 2.2314-.5238 1.0999-2.0009 1.6028-3.2265 1.8437-.8829.1965-1.7794.326-2.6818.3876-1.3588.1152-2.72391.1362-4.08558.0629-.31427 0-.61807 0-.93234-.0629-.89903-.0608-1.79208-.1904-2.67133-.3876-1.23614-.2409-2.70275-.7438-3.23701-1.8437-.16606-.3503-.251953-.7332-.25142-1.1209z",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSvg);
export default __webpack_public_path__ + "static/media/UserSVG.84fa4145.svg";
export { ForwardRef as ReactComponent };